export default "__VITE_ASSET__ykQPy_gJ__$_?url__"